const newsCategory = () => {
    const buttons = document.querySelectorAll('[data-href]');
    const blocks = document.querySelectorAll('[data-categories]');

    buttons.forEach(button => {
        button.addEventListener('click', function() {
            const filterValue = this.getAttribute('data-href');
            const isActive = this.classList.contains('active');

            // Убираем активный класс со всех кнопок
            buttons.forEach(btn => btn.classList.remove('active'));

            if (isActive) {
                // Если кнопка была активна - показываем все блоки
                blocks.forEach(block => {
                    block.style.display = 'block';
                });
            } else {
                // Активируем текущую кнопку
                this.classList.add('active');

                blocks.forEach(block => {
                    const categories = block.getAttribute('data-categories').split(',').map(cat => cat.trim());

                    if (categories.includes(filterValue)) {
                        block.style.display = 'block';
                    } else {
                        block.style.display = 'none';
                    }
                });
            }
        });
    });

}
export default newsCategory;
